interface BulkActionConfirmationModalProps {
    isStart: boolean;
    names: string[];
    noun: string;
    overflowNoun: string;
    isSelection: boolean;
    /** True while the confirmed action is in flight — disables all buttons so it can't be submitted or dismissed twice. */
    running?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

function BulkActionConfirmationModal(props: BulkActionConfirmationModalProps) {
    const { isStart, names, noun, overflowNoun, isSelection, running = false, onCancel, onConfirm } = props;
    const actionText = isStart ? 'start' : 'stop';
    const firstFiveNames = names.slice(0, 5);
    const remainingCount = names.length - firstFiveNames.length;
    const listedNames = firstFiveNames.join(', ');

    const renderMessage = () => {
        if (remainingCount > 0) {
            return (
                <>
                    This will {actionText} <strong>monitoring for {names.length} {noun}s</strong> including {listedNames} and {remainingCount} other {remainingCount === 1 ? overflowNoun : `${overflowNoun}s`}. Would you like to continue?
                </>
            );
        }

        if (listedNames) {
            return (
                <>
                    This will {actionText} <strong>monitoring for {names.length} {names.length === 1 ? noun : `${noun}s`}</strong> including {listedNames}. Would you like to continue?
                </>
            );
        }

        return (
            <>
                This will {actionText} <strong>monitoring for 0 {noun}s</strong>. Would you like to continue?
            </>
        );
    };

    return (
        <>
            <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1} aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Confirm {isStart ? 'Start' : 'Stop'} {isSelection ? 'Selected' : 'All'}
                            </h5>
                            <button type="button" className="btn-close" onClick={onCancel} disabled={running} aria-label="Close"></button>
                        </div>
                        <div className="modal-body p-3">
                            <p className="mb-0">{renderMessage()}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={running}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-success" onClick={onConfirm} disabled={running}>
                                {running && <i className="fal fa-spinner fa-spin fa-fw"></i>}
                                {running ? (isStart ? ' Starting…' : ' Stopping…') : 'Continue'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default BulkActionConfirmationModal;
